export const Routes = {
  Main: '/',
  Auctions: '/(with-breadcrumbs)/auctions/[...slug]',
  Auction: '/auction-[id]',
  Artworks: '/(with-breadcrumbs)/artworks/[...slug]',
  Artwork: '/artwork-[id]-[slug]/[[param1]]',
  Artists: '/(with-breadcrumbs)/artists/[...slug]',
  Artist: '/(with-breadcrumbs)/artist-[id]-[name]/[...slug]',
  FAQ: '/(with-breadcrumbs)/faq',
  AboutUs: '/(with-breadcrumbs)/about-us',
  ContactUs: '/(with-breadcrumbs)/contact-us',
  ArtistWalletAuthorization: '/(with-breadcrumbs)/artist-wallet-authorization/[key]',
  Process: '/(with-breadcrumbs)/process',
  Curator: '/(with-breadcrumbs)/curator-[id]-[slug]/[...searchParams]',
  News: '/(with-breadcrumbs)/news/[...slug]',
  Article: '/(with-breadcrumbs)/article-[slug]',
  SearchArtworks: '/(with-breadcrumbs)/search/artworks/[...slug]',
  SearchArtists: '/(with-breadcrumbs)/search/artists/[...slug]',
  SearchSelections: '/(with-breadcrumbs)/search/selections/[...slug]',
  Selections: '/(with-breadcrumbs)/selections/[...slug]',
  Selection: '/(with-breadcrumbs)/selection-[slug]',
};
